import { History, MessageSquare } from 'lucide-react'
import { NavLink } from 'react-router-dom'
import { Button, Card, Tooltip, TooltipContent, TooltipTrigger, useSidebar } from '@/shared/ui/primitives'
import { useFeedbackDialogContext } from '../providers'

export function SidebarFeedbackCta() {
  const { openDialog } = useFeedbackDialogContext()
  const { state, isMobile, setOpenMobile } = useSidebar()

  const handleMobileClick = () => {
    openDialog()
    setOpenMobile(false)
  }

  const closeMobile = () => {
    setOpenMobile(false)
  }

  if (isMobile) {
    return (
      <Card className="border-dashed border-sidebar-border p-3">
        <div className="flex items-center gap-2 mb-1">
          <MessageSquare className="size-4 text-muted-foreground" />
          <span className="text-sm font-semibold">We Want to Hear From You</span>
        </div>
        <p className="text-xs text-muted-foreground mb-3">Help us improve by sharing your feedback</p>
        <Button className="w-full" onClick={handleMobileClick}>
          <MessageSquare className="size-4" />
          Share Feedback
        </Button>
        <Button asChild variant="ghost" size="sm" className="mt-2 w-full">
          <NavLink to="/feedback" onClick={closeMobile}>
            <History className="size-4" />
            View your feedback
          </NavLink>
        </Button>
      </Card>
    )
  }

  if (state === 'collapsed') {
    return (
      <div className="flex flex-col items-center gap-1">
        <Tooltip>
          <TooltipTrigger asChild>
            <Button variant="ghost" size="icon" onClick={openDialog}>
              <MessageSquare className="size-4" />
            </Button>
          </TooltipTrigger>
          <TooltipContent side="right">Share Feedback</TooltipContent>
        </Tooltip>
        <Tooltip>
          <TooltipTrigger asChild>
            <Button asChild variant="ghost" size="icon">
              <NavLink to="/feedback" aria-label="View your feedback">
                <History className="size-4" />
              </NavLink>
            </Button>
          </TooltipTrigger>
          <TooltipContent side="right">View your feedback</TooltipContent>
        </Tooltip>
      </div>
    )
  }

  return (
    <Card className="border-dashed border-sidebar-border p-3">
      <div className="flex items-center gap-2">
        <MessageSquare className="size-4 text-muted-foreground" />
        <span className="text-sm font-semibold">We Want to Hear From You</span>
      </div>
      <p className="text-xs text-muted-foreground">Help us improve by sharing your feedback</p>
      <Button className="w-full" onClick={openDialog}>
        <MessageSquare className="size-4" />
        Share Feedback
      </Button>
      <Button asChild variant="ghost" size="sm" className="w-full">
        <NavLink to="/feedback" onClick={closeMobile}>
          <History className="size-4" />
          View your feedback
        </NavLink>
      </Button>
    </Card>
  )
}
